import { useDispatch, useSelector } from 'react-redux';

import { userActions } from '../../../../store/modules/user';
import { videoFolderSelectors } from '../../../../store/modules/videoFolder';

export const useDecrementEmbedStats = (projectId: string) => {
  const dispatch = useDispatch();

  const project = useSelector(state =>
    videoFolderSelectors.selectProjectById(state, projectId)
  );
  const wasEmbedded = project?.isEmbedded;

  const handleDecrementEmbedStats = () =>
    wasEmbedded && dispatch(userActions.decrementEmbedStats());

  return handleDecrementEmbedStats;
};
